module.exports = "<div class=uim-widget><div class=confirm-password-widget><div id=password-input-area class=\"input-area bottom-area-margin\"><input id=uim-uCurrentPassword-input type=password name=uCurrentPassword placeholder=\"Current Password (required)\"></div></div></div>";


//////////////////
// WEBPACK FOOTER
// ./components/ui-widgets/src/html/ConfirmPassword.html
// module id = 24
// module chunks = 0